import * as Yup from "yup";

export const validationSchema = Yup.object({
  title: Yup.string()
    .required("タイトルを入力してください。"),
  contentText: Yup.string()
    .required("本文を入力してください。"),
});
